import { DestroyRef, inject, Injectable } from '@angular/core';

import { Store } from '@ngxs/store';

import { SvgIconProp } from 'src/app/shared/models/dynamic.model';

import {

  getRpeInfoEditActionMap,

  getRpeSummaryEditDeleteActionMap,

} from 'src/app/shared/rpe/rpe-module.helper';

import { ActionIcons } from 'src/app/shared/utility/constants';

import { SmRouteKey } from 'src/app/shared/rpe/sm-rpe.constants';

import { UserEffectivePermissionsService } from './user-effective-permissions.service';

export const CURRENCY_MANAGEMENT_AUTO_SYNC_ACTION = 'auto sync';
export const USER_MANAGEMENT_SEND_EMAIL_ACTION = 'send email';

/** Page-specific icon → API actionName overrides (UI label may differ). */
const SM_PAGE_ICON_ACTION_OVERRIDES: Partial<
  Record<SmRouteKey, Record<string, string>>
> = {
  'currency-management': {
    [ActionIcons.recieveAPInvoice]: CURRENCY_MANAGEMENT_AUTO_SYNC_ACTION,
  },
  'user-management': {
    [ActionIcons.mail]: USER_MANAGEMENT_SEND_EMAIL_ACTION,
  },
};

@Injectable({

  providedIn: 'root',

})

export class SmRpeService {

  private readonly permissions = inject(UserEffectivePermissionsService);

  private readonly store = inject(Store);



  public subscribeLocationRefresh(

    destroyRef: DestroyRef,

    callback: () => void

  ): void {

    this.permissions.subscribeLocationRefresh(destroyRef, callback);

  }



  public applySummaryIcons(

    route: SmRouteKey,

    icons: SvgIconProp[],

    uniqueSelectedCount: number

  ): SvgIconProp[] {

    return this.permissions.applySetupMaintenancePageActionPermissionsToIcons(

      route,

      icons,

      {
        iconActionOverrides: {
          ...getRpeSummaryEditDeleteActionMap(uniqueSelectedCount),
          ...SM_PAGE_ICON_ACTION_OVERRIDES[route],
        },
      }

    );

  }



  public applyInfoIcons(

    route: SmRouteKey,

    icons: SvgIconProp[],

    isBulkEditView: boolean

  ): SvgIconProp[] {

    return this.permissions.applySetupMaintenancePageActionPermissionsToIcons(

      route,

      icons,

      {
        iconActionOverrides: {
          ...getRpeInfoEditActionMap(isBulkEditView),
          ...SM_PAGE_ICON_ACTION_OVERRIDES[route],
        },
      }

    );

  }



  public canPerform(route: SmRouteKey, actionName: string): boolean {

    return this.permissions.hasSetupMaintenancePageAction(route, actionName);

  }



  public canDelete(route: SmRouteKey, uniqueSelectedCount: number): boolean {

    const action =

      uniqueSelectedCount > 1 ? ActionIcons.bulkdelete : ActionIcons.delete;

    return this.canPerform(route, action);

  }

}


